import { Component, OnChanges, Input } from '@angular/core';

export interface Segment {
  key: string;
  value: any;
  type: undefined | string;
  expanded: boolean;
  visible: boolean;
  path: string;
  depth: number;
  style: object;
  status: number;
}

@Component({
  selector: 'app-json-viewer',
  templateUrl: './ngx-json-viewer.component.html',
  styleUrls: ['./ngx-json-viewer.component.scss']
})
export class NgxJsonViewerComponent implements OnChanges {

  @Input() json: any;
  @Input() jwt: string;
  @Input() setBlockScreen: ((block: boolean) => void);
  segments: Segment[] = [];
  expanded: string[] = [];

  commentPath: string;
  commentText: string;
  commentStatus: string;

  ngOnChanges() {
    this.segments = [];
    this.expanded = [];
    this.resetComment();

    if (!(typeof this.json === 'object')) {
      return;
    }
    let status = 0;
    for (const [k, v] of Object.entries(this.json)) {
      if (k !== "_id") {
        const s = this.parseElement(k, v, '', 0);
        if (s > -1) {
          status = Math.max(status, s);
        }
      }
    }
    this.segments[0].status = status;
  }

  parseElement(key: string, element: any, path: string = '', depth = 0) {
    let elementType = '';
    let value = element;
    switch (typeof element) {
      case 'number': {
        elementType = 'number';
        break;
      }
      case 'boolean': {
        elementType = 'boolean';
        break;
      }
      case 'function': {
        elementType = 'function';
        value = '()';
        break;
      }
      case 'string': {
        elementType = 'string';
        break;
      }
      case 'undefined': {
        elementType = 'undefined';
        break;
      }
      case 'object': {
        if (element === null) {
          elementType = 'null';
        } else if (Array.isArray(element)) {
          elementType = 'array';
          value = '[]';
        } else if (element instanceof Date) {
          elementType = 'date';
        } else {
          elementType = 'object';
          value = '{}';
        }
        break;
      }
    }

    const newPath = path === '' ? key : `${path}.${key}`;
    let status = -1;
    if ((key === 'status' || key === 'grade') && typeof element === 'number') {
      status = Math.floor(value);
    }
    const el = {
      key,
      value,
      type: elementType,
      expanded: false,
      visible: !depth,
      depth,
      path: newPath,
      style: {'margin-left': `${depth * 20}px`},
      status,
    };

    this.segments.push(el);

    switch (elementType) {
      case 'object': {
        for (const [k, v] of Object.entries(element)) {
          const newStatus = this.parseElement(k, v, newPath, depth + 1);
          status = Math.max(status, newStatus);
        }
        break;
      }
      case 'array': {
        for (const [i, v] of element.entries()) {
          const newStatus = this.parseElement(i.toString(), v, newPath, depth + 1);
          status = Math.max(status, newStatus);
        }
        break;
      }
    }
    el.status = status;
    return status;
  }

  isExpandable(segment: Segment) {
    return segment.type === 'object' || segment.type === 'array';
  }

  toggle(segment: Segment) {
    if (this.isExpandable(segment)) {
      segment.expanded = !segment.expanded;
      const isExpanded = segment.expanded;
      if (!isExpanded) {
        this.segments.filter(seg => seg.path
          .startsWith(segment.path))
          .forEach((seg) => {
            seg.expanded = false;
            if (seg.depth > segment.depth) {
              seg.visible = false;
            }
          });
        // this.segments = this.segments
        //   .filter(seg => !(seg.path.startsWith(segment.path)));
      } else {
        this.segments
          .filter(seg => seg.path.startsWith(segment.path) && seg.depth === segment.depth + 1)
          .forEach(seg => seg.visible = true);
      }
    }
  }

  isExpanded(key: string): boolean {
    return this.expanded.includes(key);
  }

  resetComment() {
    this.commentStatus = '';
    this.commentPath = '';
    this.commentText = '';
  }

  changeCommentStatus(status: string) {
    this.commentStatus = status;
  }

  changeCommentText(text: string) {
    this.commentText = text;
  }

  async postChange() {
    let status = 0;
    this.setBlockScreen(true);
    switch (this.commentStatus) {
      case 'Okay': status = 0; break;
      case '2. Choice': status = 1; break;
      case 'Reject': status = 4; break;
      default: break;
    }

    // TODO: Replace this with the actual server url
    const url = 'https://productionmanagerapi.biozoom.net/scanner/postComment';
    const body = {
      path: this.commentPath + '.comment',
      status,
      comment: this.commentText,
      serial: this.json.serial ?? '',
      lightbarrier: '',
    };
    if (Object.keys(this.json).includes('lightbarriers')) {
      const obj = this.json.lightbarriers[this.commentPath.split('.')[1]];
      if (!obj) {
        this.resetComment();
        this.setBlockScreen(false);
        return;
      }
      body.lightbarrier = obj._id;
      body.path = this.commentPath.split('.').slice(2).join('.');
      if (body.path.length > 0) {
        body.path += '.';
      }
      body.path += 'comment';
    }
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json; charset=UTF-8',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.jwt,
      },
      body: JSON.stringify(body)
    });
    this.resetComment();
    this.setBlockScreen(false);
  }
}
